import React from 'react';
import {Shield, FileText, AlertCircle, CreditCard, Ban, TrendingUp} from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Ban,
      title: "Nome no SPC/Serasa sem Motivo",
      description: "Seu nome foi negativado sem que você tenha sido avisado ou sem dívida válida"
    },
    {
      icon: CreditCard,
      title: "Dívida Já Foi Paga",
      description: "Você pagou a dívida mas seu nome continua sujo nos órgãos de proteção ao crédito"
    },
    {
      icon: AlertCircle,
      title: "Dívida que Você Não Reconhece",
      description: "Cobrança de valores que você nunca contratou ou não deve"
    },
    {
      icon: FileText,
      title: "Negativação Sem Aviso Prévio",
      description: "Empresa colocou seu nome no cadastro negativo sem te notificar antes"
    },
    {
      icon: Shield,
      title: "Crédito Negado Injustamente",
      description: "Não consegue financiamento, cartão ou empréstimo por erro de cadastro"
    },
    {
      icon: TrendingUp,
      title: "Direito à Indenização",
      description: "Negativação indevida gera dano moral e direito a compensação financeira"
    }
  ];

  return (
    <section id="servicos" className="py-24 bg-gradient-to-b from-white via-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block bg-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            ⚠️ Situações Mais Comuns
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Seu Caso Se Encaixa em <span className="text-blue-600">Alguma Dessas Situações?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Se você se identificou com algum dos problemas abaixo, é provável que você tenha direito a retirar a negativação e receber indenização
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white hover:bg-gradient-to-br hover:from-blue-50 hover:to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-blue-500/50"
            >
              <div className="bg-gradient-to-br from-blue-600 to-blue-700 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <service.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-slate-900 via-blue-950 to-slate-800 rounded-3xl p-12 shadow-2xl relative overflow-hidden">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-5"></div>
          
          <div className="relative z-10 text-center">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Se Identificou com Alguma Situação?
            </h3>
            <p className="text-xl text-gray-300 mb-8">
              Descubra agora se a negativação do seu nome é indevida e quanto você pode receber de indenização
            </p>
            
            <a
              href="https://wa.me/5521996853559?text=Olá Dra. Angélica, meu nome está negativado no SPC/Serasa e preciso de ajuda"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-10 py-5 rounded-2xl font-bold text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl"
            >
              <svg className="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z" />
              </svg>
              <span>Avaliar Meu Caso Agora</span>
            </a>

            <p className="text-gray-400 text-sm mt-6">
              ⚡ Atendimento direto com a advogada • 📱 Resposta rápida no WhatsApp
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;